import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "landing_applications/update/:id",
        name: "UpdateLanding",
        component: () => import("./views/updateLanding"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "landing_applications/create",
        name: "CreateLanding",
        component: () => import("./views/updateLanding"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "landing_applications",
        name: "AdminLandings",
        component: () => import("../applications/views/landingList"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
